module.exports = __webpack_public_path__ + "static/media/stopButtonHover.61a9df78.svg";